import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import CarouselImages from "../carousel-images/CarouselImages";
import { Chip, Grid, styled, Tooltip } from "@mui/material";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import LocationIcon from "@icons-rf/location-icon.svg?react";
import PropertyStatus from "../peroperty-status/PropertyStatus";
import PropertyCharacteristics from "../property-characteristics/PropertyCharacteristics";
import DescriptionContent from "../description-content/DescriptionContent";
import GeneralInformation from "../general-information/GeneralInformation";
import RemaxLogo from "@icons-rf/remax-logo.svg?react";
import LocationMap from "../location-map/LocationMap";
import MxButton from "@rf-l1/buttons/MxButton";
import { IconBuildings } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import LocationDescription from "../location-map/LocationDescription";

const MainDetailProperty = () => {
  const {
    PROPERTY_DETAIL: { principalData }
  } = useRealEstateDetailContext();

  const parentPath = () => {
    window.open(C_PATH_ROUTES.REALESTATE.DETAIL(principalData.parent_id), "_blank");
  };

  return (
    <Container>
      <CarouselImages />
      <ContainerImportantData>
        <TextSimple size="xx-title" color="blue" font="gotham" lineTruncate={1}>
          {principalData.title}
        </TextSimple>
        <ContentName>
          <TextSimple color="blue" font="gotham" size="sub-title" weight="500">
            {principalData.name}
          </TextSimple>
        </ContentName>
        <LetterIcon>
          <IconLocation />
          <TextSimple size="label" color="gray" weight="300">
            {principalData.location}
          </TextSimple>
        </LetterIcon>
        <PropertyStatus {...principalData.property_status} />
        {principalData.is_collection && (
          <Tooltip title="Esta propiedad es THE RE/MAX COLLECTION">
            <RemaxCollection
              color="primary"
              label="THE RE/MAX COLLECTION"
              icon={<RemaxLogo width={19} height={19} />}
            />
          </Tooltip>
        )}
        {principalData.parent_id !== principalData.id && (
          <Grid item marginTop={1}>
            <MxButton
              sx={{ cursor: "pointer" }}
              onClick={parentPath}
              endIcon={
                <MxIcons>
                  <IconBuildings />
                </MxIcons>
              }
            >
              Proyecto asociado
            </MxButton>
          </Grid>
        )}
        {principalData.price.map((x, i) => (
          <ColumnText key={i}>
            <TextSimple color="black" size="label" weight="300" uppercase={true}>
              {x.label}
            </TextSimple>
            <TextSimple color="red" size="x-title" font="gotham">
              {x.value}
            </TextSimple>
          </ColumnText>
        ))}

        <PropertyCharacteristics />
        {principalData.description && <DescriptionContent />}
        <GeneralInformation />
        <LocationMap />
        <LocationDescription />
      </ContainerImportantData>
    </Container>
  );
};

export default MainDetailProperty;

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  background: "#fff",
  borderRadius: "20px"
}));

const ContainerImportantData = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "0px 40px 40px",
  marginTop: "25px"
}));

const Wrapper = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "auto",
  zIndex: 1000000
}));

const LetterIcon = styled("div")(({ theme }) => ({
  marginTop: "10px",
  display: "flex",
  gap: "5px",
  alignItems: "center",
  marginBottom: "5px",
  paddingLeft: "2px"
}));

const IconLocation = styled(LocationIcon as any)(({ theme }) => ({
  color: "#e55666"
}));

const ColumnText = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  marginTop: "15px",
  marginBottom: "30px"
}));

const ContentName = styled("div")(({ theme }) => ({
  paddingLeft: "4px"
}));

const RemaxCollection = styled(Chip)(({ theme }) => ({
  height: "25px",
  fontWeight: 500,
  marginTop: "10px"
}));

const ContainerText = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "0.2rem"
}));

const IndividualContent = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  padding: "1rem 0rem",
  alignItems: "center",
  gap: "0.5rem"
}));

const Text = styled("p")(({ theme }) => ({
  display: "flex",
  fontSize: "12px"
}));

const ContentView = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  padding: "0px 0px 0px 0px",
  gap: "1rem"
}));
